import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const logo = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background-color: var(--white);

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    height: 72px;
    width: 100%;
    max-width: 1060px;
    margin: auto;
    justify-content: flex-start;
    padding-left: 16px;
  }
  @media (min-width: ${responsiveBreakpoint[1]}px) {
    padding-left: 0;
  }
`;

export const border = css`
  width: 100%;
  height: 1px;
  background: var(--gray-200);
`;

export const logoImg = css`
  width: 92px;
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    width: 128px;
  }
`;

export const hero = css`
  position: relative;
  width: 100%;
  height: auto;
  margin: auto;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    max-width: 1060px;
  }
`;

export const centerBox = css`
  padding: 24px 16px 16px;
  height: 100%;
  color: var(--gray-800);

  @media (min-width: ${responsiveBreakpoint[1]}px) {
    padding: 40px 0 24px;
  }
`;

export const title = css`
  font-weight: bold;
  font-size: 28px;
  line-height: 32px;
  letter-spacing: -0.6px;
  margin-bottom: 8px;

  @media (min-width: ${responsiveBreakpoint[1]}px) {
    font-size: 36px;
    line-height: 44px;
    letter-spacing: -0.4px;
  }
`;

export const sub = css`
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.6px;

  @media (min-width: ${responsiveBreakpoint[1]}px) {
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.3px;
  }
`;
